import React from "react";

import { useField, useFormikContext } from "formik";

import DateFnsUtils from "@date-io/date-fns";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import { FormLabel } from "./InputField";

export const DateField = ({
  label,
  fullWidth,
  name,
  required = false,
  ...props
}) => {
  const id = `${name}-input`;
  const [field, meta, helpers] = useField(name);
  const formikContext = useFormikContext();
  const { isSubmitting: disabled } = formikContext;
  const errorMessage = meta.error && meta.touched ? meta.error : "";

  const handleDateChange = (date) => {
    helpers.setValue(date);
  };

  return (
    <div
      className={
        "d-flex flex-column input-margin appbar-div-investor-flow dual-margin-investor-flow"
      }
      style={fullWidth ? { gridColumn: fullWidth } : {}}
    >
      <div className="nps-form-label" htmlFor={id}>
        {label}
        {required && "*"}
      </div>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <KeyboardDatePicker
          label=""
          disabled={disabled}
          // InputProps={{ readOnly: true }}
          error={meta.touched && Boolean(meta.error)}
          {...field}
          {...props}
          disableFuture
          format="dd/MM/yyyy"
          maxDate={
            props.isMinorAllowed
              ? new Date()
              : new Date().setFullYear(new Date().getFullYear() - 18)
          }
          value={field.value || null}
          onChange={handleDateChange}
          inputVariant="outlined"
          emptyLabel="Select Date"
          size="small"
          KeyboardButtonProps={{
            "aria-label": "change date",
          }}
        />
      </MuiPickersUtilsProvider>
      <div className="nps-error-message">{errorMessage}</div>
    </div>
  );
};

export default DateField;
